export const GOLD_LINE_INVITE_CODE = 'MLPQDT0908'
export const SILVER_LINE_INVITE_CODE = 'MLPQDT0909'
export const GREEN_LINE_INVITE_CODE = 'MLPQDT0910'
export const SECURED_CARD_INVITE_CODE = 'MLPQDT0911'
export const GENERAL_CARD_INVITE_CODE = 'MLPQDT8081'
